import "./tracking/sentry";
import "./index.css";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import App from "./App.tsx";
import { Auth0Provider } from "@auth0/auth0-react";
import type { AppState } from "@auth0/auth0-react";
import { StrictMode } from "react";
import { Toaster } from "sonner";


const root = createRoot(document.getElementById("root") as HTMLElement);

const queryClient = new QueryClient();

const organization =
  import.meta.env.VITE_APP_ENV === "production"
    ? { organization: import.meta.env.VITE_AUTH0_ORGANIZATION }
    : {};

const handleRedirectCallback = (appState?: AppState & { returnTo?: string }) => {
  const targetPath = appState?.returnTo || window.location.pathname || "/";

  if (targetPath !== window.location.pathname + window.location.search + window.location.hash) {
    window.location.replace(targetPath);
  }
};

root.render(
  <Auth0Provider
    domain={import.meta.env.VITE_AUTH0_DOMAIN || ""}
    clientId={import.meta.env.VITE_AUTH0_CLIENTID || ""}
    cacheLocation="localstorage"
    onRedirectCallback={handleRedirectCallback}
    useRefreshTokens={true}
    useRefreshTokensFallback={true}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      ...organization,
    }}
  >
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
         <Toaster richColors position="top-right" />
        <ReactQueryDevtools buttonPosition="bottom-left" />
      </QueryClientProvider>
      </StrictMode>
  </Auth0Provider>,
);
